<script setup lang="ts">
import Skeleton from '@/components/Skeleton.vue'

defineProps({
	line: {
		type: Number,
		default: 10,
	},
})

function getRandomWidth() {
	const startValue = 30
	const endValue = 90
	return Math.floor(Math.random() * (endValue - startValue + 1)) + startValue
}
</script>

<template>
	<Skeleton
		v-for="item in line"
		:key="item"
		class="mb-16px h-24px"
		:style="`width: ${getRandomWidth()}%;`"
	/>
</template>
